import { RouteConfig } from 'vue-router';
const Account = () => import('./views/account.vue');
const ZhanghuList = () => import('./views/zhanghu-list.vue');
const ZhanghuEdit = () => import('./views/zhanghu-edit.vue');
const routers: RouteConfig[] = [
    {
        path: 'account',
        name: 'account',
        component: Account
    },
    {
        path: 'zhanghu-list',
        name: 'zhanghu-list',
        component: ZhanghuList
    },
    {
        path: 'zhanghu-edit',
        name: 'zhanghu-edit',
        component: ZhanghuEdit
    },
    {
        path: '*',
        redirect: 'account'
    },
];
export default routers;

